import React from 'react'
import "./Home.css"
import PodcastGuestSearch from '../../components/Sections/PodcastGuestSearch/PodcastGuestSearch.jsx'

// import About from '../About/About.jsx'

export default function Home() {
  return (
    <div className='home-screen__container'>
      
      <PodcastGuestSearch />
            

      
    </div>
  )
}
